import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CSpinner,
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CRow,
  CCol,
  CBadge,
  CAlert
} from "@coreui/react";
import {
  FaTrash,
  FaPencilAlt,
  FaPlus,
  FaSave,
  FaTimes,
  FaSearch,
  FaInfoCircle,
  FaChevronLeft,
  FaChevronRight,
  FaCheck,
  FaEdit,
  FaUserSlash,
  FaCheckCircle
} from "react-icons/fa";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import allocateStudents1 from "../../../../assets/imgs/allocateStudents1.png";
import allocateStudents2 from "../../../../assets/imgs/allocateStudents2.png";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./styles.css";

class ClassroomMembers extends Component {
  constructor(props) {
    super(props);
    const hasSeenTutorial = localStorage.getItem("classroomTutorialShown");

    this.state = {
      roomId: parseInt(this.props.match?.params?.id || 0),
      room: null,
      roomDisciplines: [],
      serieAbbreviation: "",
      existingUsers: [],
      existingUsersPagination: {
        currentPage: 1,
        perPage: 10,
        total: 0,
        lastPage: 1
      },
      allUsers: [],
      // NOVOS ESTADOS PARA PAGINAÇÃO DOS usuarios DISPONÍVEIS
      availableUsersPagination: {
        currentPage: 1,
        perPage: 10,
        total: 0,
        lastPage: 1
      },
      loading: true,
      saving: false,
      showInformationModal: !hasSeenTutorial,
      activeIndex: 0,
      showDisciplineModal: false,
      selectedUsersForBatch: [],
      selectedDisciplinesForBatch: [],
      showEditModal: false,
      editingUser: null,
      editingDisciplines: [],
      selectedAvailableUsers: [],
      selectAllAvailable: false,
      userSearchTerm: "",
      existingUserSearchTerm: "", // NOVO: busca para usuários existentes
      pendingBatches: [],
      loadAllUsersAttempts: 0,
      selectedExistingUsers: [],
      selectAllExisting: false,
      showBatchEditModal: false,
      allClassroomUsers: [],
      showBatchDeleteConfirm: false,
      FaEdit,
      FaUserSlash,
      gradesMap: {},
      loadingGrades: false,
      rolesMap: {},
      canManageTeachers: false,
      gradeEligibleForAuxiliary: false,
      showTeachersModal: false,
      teacherRows: [],
      loadingTeachers: false,
      pendingAdministratorChanges: {},
      savingTeachers: false
    };

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.loadRoomData = this.loadRoomData.bind(this);
    this.loadExistingUsers = this.loadExistingUsers.bind(this);
    this.loadAllUsers = this.loadAllUsers.bind(this);
  }

  carouselItems = [
    {
      image: allocateStudents1,
      title: "Passo 1",
      subtitle: "Selecionar Membros",
      content:
        "Na coluna da direita, selecione os usuários que deseja adicionar à turma. Em seguida, clique em 'ATRIBUIR DISCIPLINAS' para escolher as disciplinas que eles poderão acessar."
    },
    {
      image: allocateStudents2,
      title: "Passo 2",
      subtitle: "Gerenciar Lotes",
      content:
        "Cada grupo de usuários com suas disciplinas forma um lote. Você pode criar quantos lotes quiser. Revise os lotes pendentes no topo da página antes de salvar."
    },
    {
      image: allocateStudents1,
      title: "Passo 3",
      subtitle: "Gerenciar Usuários Existentes",
      content:
        "Na coluna da esquerda, você pode MODIFICAR as disciplinas de um usuário existente ou REMOVER um usuário da turma. Essas ações são imediatas."
    }
  ];

  next() {
    this.setState(prevState => ({
      activeIndex:
        prevState.activeIndex === this.carouselItems.length - 1
          ? 0
          : prevState.activeIndex + 1
    }));
  }

  previous() {
    this.setState(prevState => ({
      activeIndex:
        prevState.activeIndex === 0
          ? this.carouselItems.length - 1
          : prevState.activeIndex - 1
    }));
  }

  goToIndex(newIndex) {
    this.setState({ activeIndex: newIndex });
  }

  async loadRoles() {
    try {
      const response = await axios.get(`${URL.api}access/role/list`, {
        headers: { Authorization: `Bearer ${this.props.user?.token}` }
      });

      console.log("Resposta roles:", response.data);

      if (response.data.success) {
        const rolesMap = {};
        response.data.data.forEach(role => {
          rolesMap[role.id] = role.name; // Ajuste conforme sua API
        });
        this.setState({ rolesMap });
        console.log("Roles map carregado:", rolesMap);
      }
    } catch (error) {
      console.error("Erro ao carregar roles:", error);
      // Tenta rota alternativa se necessário
      try {
        const response2 = await axios.get(`${URL.api}role/listAll`, {
          headers: { Authorization: `Bearer ${this.props.user?.token}` }
        });
        if (response2.data.success) {
          const rolesMap = {};
          response2.data.data.forEach(role => {
            rolesMap[role.id] = role.name;
          });
          this.setState({ rolesMap });
        }
      } catch (error2) {
        console.error("Erro também na rota alternativa:", error2);
      }
    }
  }

  async loadGrades() {
    this.setState({ loadingGrades: true });

    try {
      const response = await axios.get(`${URL.api}classification/serie/list`, {
        headers: { Authorization: `Bearer ${this.props.user?.token}` }
      });

      console.log("Resposta séries:", response.data);

      if (response.data.success) {
        const gradesMap = {};
        response.data.data.forEach(grade => {
          gradesMap[grade.id] = grade.name;
        });
        this.setState({ gradesMap });
        console.log("Grades map carregado:", gradesMap);
      }
    } catch (error) {
      console.error("Erro ao carregar séries:", error);
      toastr.error("Erro", "Não foi possível carregar as séries");
    } finally {
      this.setState({ loadingGrades: false });
    }
  }

  async loadTeacherManagementInfo() {
    try {
      const response = await axios.get(
        `${URL.api}community/room_user/teacherManagementInfo/${this.state.roomId}`,
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        this.setState({
          canManageTeachers: response.data.data.can_manage,
          gradeEligibleForAuxiliary: response.data.data.grade_eligible
        });
      }
    } catch (error) {
      console.error("Erro ao carregar permissões de professores:", error);
    }
  }

  componentDidCatch(error, errorInfo) {
    console.error("Erro capturado no componente:", error);
    console.error("Info do erro:", errorInfo);
    toastr.error(
      "Erro inesperado",
      error.message || "Ocorreu um erro ao carregar a página"
    );
  }

  componentDidMount() {
    console.log("=== componentDidMount INICIADO ===");
    console.log("Room ID:", this.state.roomId);

    if (this.props.setObj && this.props.currentRoute) {
      this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    }

    this.loadRoomData();
    this.loadExistingUsers();
    this.loadGrades();
    this.loadRoles();
    this.loadTeacherManagementInfo();
  }

  async loadRoomData() {
    console.log("=== loadRoomData INICIADO ===");
    try {
      const response = await axios.get(
        `${URL.api}community/room/singleView/${this.state.roomId}`,
        {
          headers: { Authorization: `Bearer ${this.props.user?.token}` }
        }
      );

      console.log("Resposta loadRoomData:", response.data);

      if (response.data.success) {
        const roomData = response.data.data.room;
        const roomDisciplines = response.data.data.room_discipline || [];

        // CORREÇÃO: Usar "room_user" em vez de "users"
        const rawUsers = response.data.data.room_user || [];

        // Mapear os usuários para garantir que tenham role_name
        const allClassroomUsers = rawUsers.map(user => ({
          id: user.id,
          user_id: user.user_id,
          name: user.user_name,
          email: user.username || `${user.user_name}@exemplo.com`,
          role_name: user.role_name || "Usuário",
          role_id: user.role_id,
          user_disciplines: []
        }));

        console.log("Todos os usuários da turma (room_user):");
        console.log("Total de usuários:", allClassroomUsers.length);

        // Log para ver os tipos de usuários
        const roleCounts = {};
        allClassroomUsers.forEach(user => {
          const role = user.role_name;
          roleCounts[role] = (roleCounts[role] || 0) + 1;
        });
        console.log("Contagem por tipo:", roleCounts);

        const firstDiscipline = roomDisciplines[0];

        this.setState(
          prevState => ({
            room: roomData,
            roomDisciplines,
            allClassroomUsers,
            existingUsersPagination: {
              ...prevState.existingUsersPagination,
              total: allClassroomUsers.length
            },
            serieAbbreviation:
              firstDiscipline?.serie_abbreviation ||
              firstDiscipline?.serie_name ||
              ""
          }),
          () => {
            console.log("State room atualizado:", {
              room: this.state.room,
              totalUsers: this.state.allClassroomUsers?.length
            });
            this.loadAllUsers();
          }
        );
      } else {
        console.error("Erro na resposta da API:", response.data);
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Erro ao carregar turma:", error);
      toastr.error("Erro", "Não foi possível carregar os dados da turma");
      this.setState({ loading: false });
    }
  }

  async refreshClassroomData() {
    try {
      const response = await axios.get(
        `${URL.api}community/room/singleView/${this.state.roomId}`,
        {
          headers: { Authorization: `Bearer ${this.props.user?.token}` }
        }
      );

      if (response.data.success) {
        // CORREÇÃO: Usar "room_user" em vez de "users"
        const rawUsers = response.data.data.room_user || [];
        const allClassroomUsers = rawUsers.map(user => ({
          id: user.id,
          user_id: user.user_id,
          name: user.user_name,
          email: user.username || `${user.user_name}@exemplo.com`,
          role_name: user.role_name || "Usuário",
          role_id: user.role_id,
          user_disciplines: []
        }));

        this.setState(prevState => ({
          allClassroomUsers,
          existingUsersPagination: {
            ...prevState.existingUsersPagination,
            total: allClassroomUsers.length
          }
        }));

        console.log("Dados da turma atualizados. Total de usuários:");
        console.log("Usuários por tipo:", this.getUserTypeCounts());

        return allClassroomUsers;
      }
    } catch (error) {
      console.error("Erro ao atualizar dados da turma:", error);
      return [];
    }
  }

  async loadExistingUsers(page = 1) {
    console.log("=== loadExistingUsers INICIADO ===", {
      page,
      roomId: this.state.roomId
    });
    try {
      const response = await axios.post(
        `${URL.api}community/room_user/listPaginate`,
        {
          room: this.state.roomId,
          page,
          offset: this.state.existingUsersPagination.perPage
        },
        {
          headers: { Authorization: `Bearer ${this.props.user?.token}` }
        }
      );

      console.log("Resposta loadExistingUsers:", response.data);

      if (response.data.success) {
        const usersData = response.data.data.users || [];
        const disciplinesData = response.data.data.disciplines || [];

        const usersWithDisciplines = usersData.map(user => ({
          id: user.id,
          user_id: user.user_id,
          name: user.user_name,
          email: user.username,
          role_id: user.role_id,
          role_name: user.role_name || "Usuário",
          administrator: !!user.administrator,
          user_disciplines: disciplinesData.filter(
            d => d.room_user_id === user.id
          )
        }));

        // CORREÇÃO: Usar callback function
        this.setState(
          prevState => ({
            existingUsers: usersWithDisciplines,
            existingUsersPagination: {
              ...prevState.existingUsersPagination,
              currentPage: page,
              total: response.data.meta?.total || 0,
              lastPage: response.data.meta?.last_page || 1
            },
            loading: false
          }),
          () => {
            console.log(
              "State existingUsers atualizado:",
              this.state.existingUsers
            );
            console.log(
              "Nomes dos usuários:",
              this.state.existingUsers.map(u => u.name)
            );
          }
        );
      }
    } catch (error) {
      console.error("Erro ao carregar usuários:", error);
      toastr.error("Erro", "Não foi possível carregar os usuários da turma");
      this.setState({ loading: false });
    }
  }

  async loadAllUsers() {
    const { room, loadAllUsersAttempts, gradesMap, rolesMap } = this.state;

    const groupId = room?.group_id;
    const regionId = room?.region_id;
    const schoolId = room?.school_id;

    if (!groupId || !regionId || !schoolId) {
      if (loadAllUsersAttempts >= 5) {
        console.error("Falha ao carregar usuários após 5 tentativas");
        toastr.error("Erro", "Não foi possível carregar a lista de usuários");
        this.setState({ loading: false });
        return;
      }

      setTimeout(() => {
        this.setState(
          prevState => ({
            loadAllUsersAttempts: prevState.loadAllUsersAttempts + 1
          }),
          () => {
            this.loadAllUsers();
          }
        );
      }, 1000);
      return;
    }

    this.setState({ loadAllUsersAttempts: 0 });

    const payload = {
      group: groupId,
      region: regionId,
      school: schoolId
    };

    try {
      const response = await axios.post(
        `${URL.api}access/user/listWithEnrollmentsByFilters`,
        payload,
        {
          headers: { Authorization: `Bearer ${this.props.user?.token}` }
        }
      );

      if (response.data.success) {
        const usersWithEnrollments = response.data.data;
      }

      if (response.data.success) {
        const usersWithEnrollments = response.data.data;

        const users = usersWithEnrollments.map(user => {
          // Pega todos os grade_ids únicos de todas as enturmações do usuário
          const allGradeIds = [];
          const allGradeNames = [];

          user.enrollments?.forEach(enrollment => {
            if (enrollment.grade_ids && enrollment.grade_ids.length > 0) {
              enrollment.grade_ids.forEach(gradeId => {
                if (!allGradeIds.includes(gradeId)) {
                  allGradeIds.push(gradeId);
                  const gradeName = gradesMap[gradeId] || `Série ${gradeId}`;
                  allGradeNames.push(gradeName);
                }
              });
            }
          });

          // CORREÇÃO: Busca o role_name baseado no role_id (igual à primeira tabela)
          let roleName = "Usuário";

          // Tenta encontrar o role_id nos enrollments
          if (user.enrollments && user.enrollments.length > 0) {
            // Procura o primeiro enrollment que tem role_id
            const enrollmentWithRole = user.enrollments.find(e => e.role_id);
            if (enrollmentWithRole && enrollmentWithRole.role_id) {
              roleName = rolesMap[enrollmentWithRole.role_id] || "Usuário";
            }
          }

          // Se tiver role_id diretamente no usuário
          if (user.role_id) {
            roleName = rolesMap[user.role_id] || "Usuário";
          }

          return {
            id: user.id,
            name: user.name,
            email: user.email,
            role_name: roleName, // Agora igual à primeira tabela
            enrollments: user.enrollments || [],
            grade_ids: allGradeIds,
            grade_names: allGradeNames
          };
        });

        this.setState({ allUsers: users }, () => {
          console.log("State allUsers atualizado:", this.state.allUsers.length);
          console.log("Primeiro usuário com role:", this.state.allUsers[0]);
        });
      } else {
        console.error("Erro na resposta da API:", response.data);
      }
    } catch (error) {
      console.error("Erro ao carregar usuários:", error);
      toastr.error("Erro", "Não foi possível carregar a lista de usuários");
    }
  }

  getPaginatedAvailableUsers = () => {
    const {
      allUsers,
      existingUsers,
      existingUserSearchTerm,
      availableUsersPagination
    } = this.state;

    // Filtra os usuários disponíveis (que NÃO estão na turma)
    const existingUserIds = existingUsers.map(u => u.user_id);
    let available = allUsers.filter(user => !existingUserIds.includes(user.id));

    // Aplica busca se houver termo
    if (existingUserSearchTerm) {
      available = available.filter(
        user =>
          user.name
            ?.toLowerCase()
            .includes(existingUserSearchTerm.toLowerCase()) ||
          user.email
            ?.toLowerCase()
            .includes(existingUserSearchTerm.toLowerCase())
      );
    }

    // ORDENAÇÃO: Primeiro sem grade_ids, depois com grade_ids, ambos em ordem alfabética
    const usersWithoutGrades = [];
    const usersWithGrades = [];

    available.forEach(user => {
      const hasGrade = user.enrollments?.some(
        enrollment => enrollment.grade_ids && enrollment.grade_ids.length > 0
      );

      if (hasGrade) {
        usersWithGrades.push(user);
      } else {
        usersWithoutGrades.push(user);
      }
    });

    // Ordena alfabeticamente
    usersWithoutGrades.sort((a, b) =>
      (a.name || "").localeCompare(b.name || "")
    );
    usersWithGrades.sort((a, b) => (a.name || "").localeCompare(b.name || ""));

    // Junta: primeiro sem grades, depois com grades
    let sortedAvailable = [...usersWithoutGrades, ...usersWithGrades];

    // Atualiza total e última página
    const total = sortedAvailable.length;
    const lastPage = Math.ceil(total / availableUsersPagination.perPage);

    // Aplica paginação
    const start =
      (availableUsersPagination.currentPage - 1) *
      availableUsersPagination.perPage;
    const end = start + availableUsersPagination.perPage;
    const paginatedUsers = sortedAvailable.slice(start, end);

    return {
      users: paginatedUsers,
      total,
      lastPage,
      currentPage: availableUsersPagination.currentPage
    };
  };

  handleAvailableUsersPageChange = newPage => {
    this.setState(prevState => ({
      availableUsersPagination: {
        ...prevState.availableUsersPagination,
        currentPage: newPage
      }
    }));
  };

  handleAvailableUsersSearch = searchTerm => {
    this.setState(prevState => ({
      existingUserSearchTerm: searchTerm,
      availableUsersPagination: {
        ...prevState.availableUsersPagination,
        currentPage: 1
      }
    }));
  };

  getAvailableUsers = () => {
    const { allUsers, existingUsers, userSearchTerm } = this.state;

    console.log("=== getAvailableUsers ===");
    console.log("allUsers length:", allUsers.length);
    console.log("existingUsers length:", existingUsers.length);

    // Mapeia os IDs dos usuários existentes
    const existingUserIds = existingUsers.map(u => u.user_id);
    console.log("existingUserIds:", existingUserIds);

    let available = allUsers.filter(user => !existingUserIds.includes(user.id));
    console.log("available após filtro inicial:", available.length);

    if (userSearchTerm) {
      available = available.filter(
        user =>
          user.name?.toLowerCase().includes(userSearchTerm.toLowerCase()) ||
          user.email?.toLowerCase().includes(userSearchTerm.toLowerCase())
      );
      console.log("available após filtro de busca:", available.length);
    }

    return available;
  };

  // No handleRemoveUser
  handleRemoveUser = async user => {
    if (
      !window.confirm(`Tem certeza que deseja remover ${user.name} da turma?`)
    ) {
      return;
    }

    try {
      const response = await axios.post(
        `${URL.api}community/room_user/delete/${user.id}`,
        {},
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        toastr.success("Sucesso", "Usuário removido da turma!");

        // ATUALIZAR: Recarregar dados da turma e lista paginada
        await this.refreshClassroomData(); // Atualiza o total
        await this.loadExistingUsers(
          this.state.existingUsersPagination.currentPage
        );
        await this.loadAllUsers();
      } else {
        toastr.error("Erro", response.data.error || "Erro ao remover usuário");
      }
    } catch (error) {
      console.error("Erro ao remover:", error);
      toastr.error("Erro", "Não foi possível remover o usuário");
    }
  };

  // No handleConfirmBatch
  handleConfirmBatch = async () => {
    const { selectedUsersForBatch, selectedDisciplinesForBatch, roomId } =
      this.state;

    if (selectedDisciplinesForBatch.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos uma disciplina");
      return;
    }

    if (selectedUsersForBatch.length === 0) {
      toastr.warning("Atenção", "Nenhum usuário selecionado");
      return;
    }

    this.setState({ saving: true });

    try {
      const payload = {
        data: selectedUsersForBatch.map(user => ({
          room_id: roomId,
          user_id: user.id,
          administrator: false,
          start: new Date().toISOString().split("T")[0],
          authorized: true,
          request: false,
          disciplines: selectedDisciplinesForBatch
        }))
      };

      const response = await axios.post(
        `${URL.api}community/room_user/insertMany`,
        payload,
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        toastr.success(
          "Sucesso",
          `${selectedUsersForBatch.length} usuário(s) adicionado(s) à turma!`
        );

        // ATUALIZAR: Recarregar dados da turma e listas
        await this.refreshClassroomData(); // Atualiza o total
        await this.loadExistingUsers(1);
        await this.loadAllUsers();

        // Limpa os estados
        this.setState({
          showDisciplineModal: false,
          selectedUsersForBatch: [],
          selectedDisciplinesForBatch: [],
          selectedAvailableUsers: [],
          selectAllAvailable: false,
          existingUserSearchTerm: ""
        });
      } else {
        toastr.error(
          "Erro",
          response.data.error || "Erro ao adicionar usuários"
        );
      }
    } catch (error) {
      console.error("Erro ao adicionar usuários:", error);
      toastr.error("Erro", "Não foi possível adicionar os usuários");
    } finally {
      this.setState({ saving: false });
    }
  };

  // No handleSaveEdit
  handleSaveEdit = async () => {
    const { editingUser, editingDisciplines } = this.state;

    this.setState({ saving: true });

    try {
      const payload = {
        id: editingUser.id,
        disciplines: editingDisciplines,
        administrator: editingUser.administrator || false,
        authorized: true,
        request: false,
        start: editingUser.start || new Date().toISOString().split("T")[0]
      };

      const response = await axios.post(
        `${URL.api}community/room_user/update/${editingUser.id}`,
        payload,
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        toastr.success("Sucesso", "Disciplinas atualizadas!");

        // ATUALIZAR: Recarregar dados da turma
        await this.refreshClassroomData();

        this.setState({
          showEditModal: false,
          editingUser: null,
          editingDisciplines: []
        });
        this.loadExistingUsers(this.state.existingUsersPagination.currentPage);
      } else {
        toastr.error("Erro", response.data.error || "Erro ao atualizar");
      }
    } catch (error) {
      console.error("Erro ao atualizar:", error);
      toastr.error("Erro", "Não foi possível atualizar as disciplinas");
    } finally {
      this.setState({ saving: false });
    }
  };

  // No handleBatchDelete
  handleBatchDelete = async () => {
    const { selectedExistingUsers } = this.state;

    this.setState({ saving: true });

    try {
      const promises = selectedExistingUsers.map(userId => {
        const user = this.state.existingUsers.find(u => u.id === userId);
        if (!user) return Promise.resolve();

        return axios.post(
          `${URL.api}community/room_user/delete/${user.id}`,
          {},
          { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
        );
      });

      const responses = await Promise.all(promises);
      const allSuccess = responses.every(r => r?.data?.success);

      if (allSuccess) {
        toastr.success(
          "Sucesso",
          `${selectedExistingUsers.length} usuário(s) removido(s)!`
        );

        // ATUALIZAR: Recarregar dados da turma
        await this.refreshClassroomData();

        this.setState({
          showBatchDeleteConfirm: false,
          selectedExistingUsers: [],
          selectAllExisting: false
        });
        this.loadExistingUsers(this.state.existingUsersPagination.currentPage);
        this.loadAllUsers();
      } else {
        toastr.error("Erro", "Alguns usuários não foram removidos");
      }
    } catch (error) {
      console.error("Erro ao remover em lote:", error);
      toastr.error("Erro", "Não foi possível remover os usuários");
    } finally {
      this.setState({ saving: false });
    }
  };

  // No handleBatchEditSave
  handleBatchEditSave = async () => {
    const { selectedExistingUsers, editingDisciplines } = this.state;

    if (editingDisciplines.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos uma disciplina");
      return;
    }

    this.setState({ saving: true });

    try {
      const promises = selectedExistingUsers.map(userId => {
        const user = this.state.existingUsers.find(u => u.id === userId);
        if (!user) return Promise.resolve();

        const payload = {
          id: user.id,
          disciplines: editingDisciplines,
          administrator: user.administrator || false,
          authorized: true,
          request: false,
          start: user.start || new Date().toISOString().split("T")[0]
        };

        return axios.post(
          `${URL.api}community/room_user/update/${user.id}`,
          payload,
          { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
        );
      });

      const responses = await Promise.all(promises);
      const allSuccess = responses.every(r => r?.data?.success);

      if (allSuccess) {
        toastr.success(
          "Sucesso",
          `${selectedExistingUsers.length} usuário(s) atualizado(s)!`
        );

        // ATUALIZAR: Recarregar dados da turma
        await this.refreshClassroomData();

        this.setState({
          showBatchEditModal: false,
          selectedExistingUsers: [],
          selectAllExisting: false,
          editingDisciplines: []
        });
        this.loadExistingUsers(this.state.existingUsersPagination.currentPage);
      } else {
        toastr.error("Erro", "Alguns usuários não foram atualizados");
      }
    } catch (error) {
      console.error("Erro ao atualizar em lote:", error);
      toastr.error("Erro", "Não foi possível atualizar os usuários");
    } finally {
      this.setState({ saving: false });
    }
  };

  handleEditUser = user => {
    const userDisciplineIds =
      user.user_disciplines?.map(d => d.room_discipline_id) || [];

    this.setState({
      showEditModal: true,
      editingUser: user,
      editingDisciplines: userDisciplineIds
    });
  };

  handleSaveEdit = async () => {
    const { editingUser, editingDisciplines } = this.state;

    this.setState({ saving: true });

    try {
      const payload = {
        id: editingUser.id,
        disciplines: editingDisciplines,
        administrator: editingUser.administrator || false,
        authorized: true,
        request: false,
        start: editingUser.start || new Date().toISOString().split("T")[0]
      };

      const response = await axios.post(
        `${URL.api}community/room_user/update/${editingUser.id}`,
        payload,
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        toastr.success("Sucesso", "Disciplinas atualizadas!");
        this.setState({
          showEditModal: false,
          editingUser: null,
          editingDisciplines: []
        });
        this.loadExistingUsers(this.state.existingUsersPagination.currentPage);
      } else {
        toastr.error("Erro", response.data.error || "Erro ao atualizar");
      }
    } catch (error) {
      console.error("Erro ao atualizar:", error);
      toastr.error("Erro", "Não foi possível atualizar as disciplinas");
    } finally {
      this.setState({ saving: false });
    }
  };

  handleOpenTeachersModal = async () => {
    this.setState({
      showTeachersModal: true,
      loadingTeachers: true,
      pendingAdministratorChanges: {}
    });

    try {
      const response = await axios.post(
        `${URL.api}community/room_user/listPaginate`,
        { room: this.state.roomId, role_id: 6, offset: 1000 },
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        const teacherRows = (response.data.data.users || []).map(user => ({
          id: user.id,
          name: user.user_name,
          administrator: !!user.administrator
        }));

        this.setState({ teacherRows });
      } else {
        toastr.error(
          "Erro",
          "Não foi possível carregar os professores da turma"
        );
      }
    } catch (error) {
      console.error("Erro ao carregar professores:", error);
      toastr.error("Erro", "Não foi possível carregar os professores da turma");
    } finally {
      this.setState({ loadingTeachers: false });
    }
  };

  handleTeacherToggle = (teacherId, currentValue) => {
    this.setState(prevState => ({
      pendingAdministratorChanges: {
        ...prevState.pendingAdministratorChanges,
        [teacherId]: !currentValue
      }
    }));
  };

  handleCancelTeachersModal = () => {
    this.setState({
      showTeachersModal: false,
      pendingAdministratorChanges: {}
    });
  };

  handleSaveTeachers = async () => {
    const { pendingAdministratorChanges } = this.state;
    const changedIds = Object.keys(pendingAdministratorChanges);

    if (changedIds.length === 0) {
      this.setState({ showTeachersModal: false });
      return;
    }

    this.setState({ savingTeachers: true });

    try {
      const responses = await Promise.all(
        changedIds.map(id =>
          axios.post(
            `${URL.api}community/room_user/setAdministrator/${id}`,
            { administrator: pendingAdministratorChanges[id] },
            { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
          )
        )
      );

      const allSuccess = responses.every(r => r?.data?.success);

      if (allSuccess) {
        toastr.success("Sucesso", "Professores atualizados!");
        this.setState({
          showTeachersModal: false,
          pendingAdministratorChanges: {}
        });
        this.loadExistingUsers(this.state.existingUsersPagination.currentPage);
      } else {
        toastr.error("Erro", "Alguns professores não foram atualizados");
      }
    } catch (error) {
      console.error("Erro ao atualizar professores:", error);
      toastr.error("Erro", "Não foi possível atualizar os professores");
    } finally {
      this.setState({ savingTeachers: false });
    }
  };

  toggleSelectUser = userId => {
    this.setState(prevState => {
      const isSelected = prevState.selectedAvailableUsers.includes(userId);
      const newSelected = isSelected
        ? prevState.selectedAvailableUsers.filter(id => id !== userId)
        : [...prevState.selectedAvailableUsers, userId];

      const availableUsers = this.getAvailableUsers();
      return {
        selectedAvailableUsers: newSelected,
        selectAllAvailable: newSelected.length === availableUsers.length
      };
    });
  };

  toggleSelectAllUsers = () => {
    this.setState(prevState => {
      const newSelectAll = !prevState.selectAllAvailable;
      const availableUsers = this.getAvailableUsers();
      return {
        selectAllAvailable: newSelectAll,
        selectedAvailableUsers: newSelectAll
          ? availableUsers.map(u => u.id)
          : []
      };
    });
  };

  handleOpenDisciplineModal = () => {
    if (this.state.selectedAvailableUsers.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos um usuário");
      return;
    }

    const availableUsers = this.getAvailableUsers();
    const selectedUsersData = availableUsers.filter(u =>
      this.state.selectedAvailableUsers.includes(u.id)
    );

    this.setState({
      showDisciplineModal: true,
      selectedUsersForBatch: selectedUsersData,
      selectedDisciplinesForBatch: []
    });
  };

  handleConfirmBatch = async () => {
    const { selectedUsersForBatch, selectedDisciplinesForBatch, roomId } =
      this.state;

    if (selectedDisciplinesForBatch.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos uma disciplina");
      return;
    }

    if (selectedUsersForBatch.length === 0) {
      toastr.warning("Atenção", "Nenhum usuário selecionado");
      return;
    }

    this.setState({ saving: true });

    try {
      const payload = {
        data: selectedUsersForBatch.map(user => ({
          room_id: roomId,
          user_id: user.id,
          administrator: false,
          start: new Date().toISOString().split("T")[0],
          authorized: true,
          request: false,
          disciplines: selectedDisciplinesForBatch
        }))
      };

      const response = await axios.post(
        `${URL.api}community/room_user/insertMany`,
        payload,
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        toastr.success(
          "Sucesso",
          `${selectedUsersForBatch.length} usuário(s) adicionado(s) à turma!`
        );

        // Limpa os estados
        this.setState({
          showDisciplineModal: false,
          selectedUsersForBatch: [],
          selectedDisciplinesForBatch: [],
          selectedAvailableUsers: [],
          selectAllAvailable: false,
          existingUserSearchTerm: ""
        });

        // Recarrega as listas
        await this.loadExistingUsers(1);
        await this.loadAllUsers(); // Recarrega com a nova rota
      } else {
        toastr.error(
          "Erro",
          response.data.error || "Erro ao adicionar usuários"
        );
      }
    } catch (error) {
      console.error("Erro ao adicionar usuários:", error);
      toastr.error("Erro", "Não foi possível adicionar os usuários");
    } finally {
      this.setState({ saving: false });
    }
  };

  // ADICIONAR: Método para adicionar múltiplos usuários instantaneamente
  handleAddMultipleUsers = async (users, disciplines) => {
    this.setState({ saving: true });

    try {
      const payload = {
        data: users.map(user => ({
          room_id: this.state.roomId,
          user_id: user.id,
          administrator: false,
          start: new Date().toISOString().split("T")[0],
          authorized: true,
          request: false,
          disciplines
        }))
      };

      const response = await axios.post(
        `${URL.api}community/room_user/insertMany`,
        payload,
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        toastr.success(
          "Sucesso",
          `${users.length} usuário(s) adicionado(s) à turma!`
        );

        // Atualiza as listas instantaneamente
        await this.loadExistingUsers(1);
        await this.loadAllUsers();

        // Limpa seleção
        this.setState({
          selectedAvailableUsers: [],
          selectAllAvailable: false
        });
      } else {
        toastr.error(
          "Erro",
          response.data.error || "Erro ao adicionar usuários"
        );
      }
    } catch (error) {
      console.error("Erro ao adicionar múltiplos usuários:", error);
      toastr.error("Erro", "Não foi possível adicionar os usuários");
    } finally {
      this.setState({ saving: false });
    }
  };

  handleRemoveBatch = batchId => {
    this.setState(prevState => ({
      pendingBatches: prevState.pendingBatches.filter(b => b.id !== batchId)
    }));
    toastr.info("Info", "Lote removido");
  };

  // MODIFICAR: handleSaveAllBatches para melhor performance
  handleSaveAllBatches = async () => {
    const { pendingBatches, roomId } = this.state;

    if (pendingBatches.length === 0) {
      toastr.warning("Atenção", "Nenhum lote para salvar");
      return;
    }

    // Mostra confirm dialog
    if (
      !window.confirm(
        `Salvar ${pendingBatches.reduce(
          (sum, b) => sum + b.users.length,
          0
        )} usuário(s) instantaneamente?`
      )
    ) {
      return;
    }

    const payload = { data: [] };

    pendingBatches.forEach(batch => {
      batch.users.forEach(user => {
        payload.data.push({
          room_id: roomId,
          user_id: user.id,
          administrator: false,
          start: new Date().toISOString().split("T")[0],
          authorized: true,
          request: false,
          disciplines: batch.disciplines
        });
      });
    });

    this.setState({ saving: true });

    try {
      const response = await axios.post(
        `${URL.api}community/room_user/insertMany`,
        payload,
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        toastr.success(
          "Sucesso",
          `${payload.data.length} usuário(s) adicionado(s) instantaneamente!`
        );
        this.setState({ pendingBatches: [] });
        await this.loadExistingUsers(1);
        await this.loadAllUsers();
      } else {
        toastr.error("Erro", response.data.error || "Erro ao adicionar");
      }
    } catch (error) {
      console.error("Erro ao salvar:", error);
      toastr.error("Erro", "Não foi possível adicionar os usuários");
    } finally {
      this.setState({ saving: false });
    }
  };

  handleCancelAllBatches = () => {
    if (this.state.pendingBatches.length === 0) return;

    if (window.confirm("Cancelar todos os lotes pendentes?")) {
      this.setState({ pendingBatches: [] });
      toastr.info("Info", "Todos os lotes foram cancelados");
    }
  };

  // Adicione estes métodos após os métodos existentes

  // Toggle seleção de um usuário existente
  toggleSelectExistingUser = userId => {
    this.setState(prevState => {
      const isSelected = prevState.selectedExistingUsers.includes(userId);
      const newSelected = isSelected
        ? prevState.selectedExistingUsers.filter(id => id !== userId)
        : [...prevState.selectedExistingUsers, userId];

      return {
        selectedExistingUsers: newSelected,
        selectAllExisting: newSelected.length === prevState.existingUsers.length
      };
    });
  };

  // Toggle selecionar todos os usuários existentes
  toggleSelectAllExisting = () => {
    this.setState(prevState => {
      const newSelectAll = !prevState.selectAllExisting;
      return {
        selectAllExisting: newSelectAll,
        selectedExistingUsers: newSelectAll
          ? prevState.existingUsers.map(u => u.id)
          : []
      };
    });
  };

  // Abrir modal de edição em lote
  handleBatchEdit = () => {
    if (this.state.selectedExistingUsers.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos um usuário");
      return;
    }

    this.setState({ showBatchEditModal: true });
  };

  // Salvar edição em lote (disciplinas)
  handleBatchEditSave = async () => {
    const { selectedExistingUsers, editingDisciplines } = this.state;

    if (editingDisciplines.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos uma disciplina");
      return;
    }

    this.setState({ saving: true });

    try {
      // Processa cada usuário selecionado
      const promises = selectedExistingUsers.map(userId => {
        const user = this.state.existingUsers.find(u => u.id === userId);
        if (!user) return Promise.resolve();

        const payload = {
          id: user.id,
          disciplines: editingDisciplines,
          administrator: user.administrator || false,
          authorized: true,
          request: false,
          start: user.start || new Date().toISOString().split("T")[0]
        };

        return axios.post(
          `${URL.api}community/room_user/update/${user.id}`,
          payload,
          { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
        );
      });

      const responses = await Promise.all(promises);
      const allSuccess = responses.every(r => r?.data?.success);

      if (allSuccess) {
        toastr.success(
          "Sucesso",
          `${selectedExistingUsers.length} usuário(s) atualizado(s)!`
        );
        this.setState({
          showBatchEditModal: false,
          selectedExistingUsers: [],
          selectAllExisting: false,
          editingDisciplines: []
        });
        this.loadExistingUsers(this.state.existingUsersPagination.currentPage);
      } else {
        toastr.error("Erro", "Alguns usuários não foram atualizados");
      }
    } catch (error) {
      console.error("Erro ao atualizar em lote:", error);
      toastr.error("Erro", "Não foi possível atualizar os usuários");
    } finally {
      this.setState({ saving: false });
    }
  };

  // Confirmar exclusão em lote
  handleBatchDeleteConfirm = () => {
    if (this.state.selectedExistingUsers.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos um usuário");
      return;
    }

    this.setState({ showBatchDeleteConfirm: true });
  };

  // Executar exclusão em lote
  handleBatchDelete = async () => {
    const { selectedExistingUsers } = this.state;

    this.setState({ saving: true });

    try {
      const promises = selectedExistingUsers.map(userId => {
        const user = this.state.existingUsers.find(u => u.id === userId);
        if (!user) return Promise.resolve();

        return axios.post(
          `${URL.api}community/room_user/delete/${user.id}`,
          {},
          { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
        );
      });

      const responses = await Promise.all(promises);
      const allSuccess = responses.every(r => r?.data?.success);

      if (allSuccess) {
        toastr.success(
          "Sucesso",
          `${selectedExistingUsers.length} usuário(s) removido(s)!`
        );
        this.setState({
          showBatchDeleteConfirm: false,
          selectedExistingUsers: [],
          selectAllExisting: false
        });
        this.loadExistingUsers(this.state.existingUsersPagination.currentPage);
        this.loadAllUsers();
      } else {
        toastr.error("Erro", "Alguns usuários não foram removidos");
      }
    } catch (error) {
      console.error("Erro ao remover em lote:", error);
      toastr.error("Erro", "Não foi possível remover os usuários");
    } finally {
      this.setState({ saving: false });
    }
  };

  // ADICIONAR: Método para adicionar usuário individual (instantâneo)
  handleAddSingleUser = async (user, selectedDisciplines) => {
    if (!selectedDisciplines || selectedDisciplines.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos uma disciplina");
      return;
    }

    this.setState({ saving: true });

    try {
      const payload = {
        room_id: this.state.roomId,
        user_id: user.id,
        administrator: false,
        start: new Date().toISOString().split("T")[0],
        authorized: true,
        request: false,
        disciplines: selectedDisciplines
      };

      const response = await axios.post(
        `${URL.api}community/room_user/insertMany`,
        { data: [payload] },
        { headers: { Authorization: `Bearer ${this.props.user?.token}` } }
      );

      if (response.data.success) {
        toastr.success("Sucesso", `${user.name} adicionado à turma!`);

        // Atualiza as listas instantaneamente
        await this.loadExistingUsers(1);
        await this.loadAllUsers();

        // Limpa seleção
        this.setState({
          selectedAvailableUsers: [],
          selectAllAvailable: false,
          userSearchTerm: "" // Opcional: limpar busca
        });
      } else {
        toastr.error(
          "Erro",
          response.data.error || "Erro ao adicionar usuário"
        );
      }
    } catch (error) {
      console.error("Erro ao adicionar usuário:", error);
      toastr.error("Erro", "Não foi possível adicionar o usuário");
    } finally {
      this.setState({ saving: false });
    }
  };

  getUserTypeCounts = () => {
    const { allClassroomUsers } = this.state;

    console.log("getUserTypeCounts - allClassroomUsers:", allClassroomUsers);
    console.log("allClassroomUsers length:", allClassroomUsers?.length);

    if (!allClassroomUsers || allClassroomUsers.length === 0) {
      return { Total: 0 };
    }

    const counts = {};

    allClassroomUsers.forEach(user => {
      const roleName = user.role_name || "Usuário";
      counts[roleName] = (counts[roleName] || 0) + 1;
    });

    console.log("Counts calculados:", counts);
    return counts;
  };

  renderUserTypeCounts = () => {
    const { allClassroomUsers } = this.state;
    const counts = this.getUserTypeCounts();
    const total = allClassroomUsers?.length || 0;

    console.log("renderUserTypeCounts - total:", total);
    console.log("renderUserTypeCounts - counts:", counts);

    if (total === 0) {
      return <span>Usuários na turma</span>;
    }

    const getBadgeColor = type => {
      switch (type) {
        case "Estudante":
          return "info";
        case "Professor":
          return "success";
        case "Administrador Escolar":
          return "danger";
        default:
          return "secondary";
      }
    };

    return (
      <div>
        <span className="mr-2">Usuários na turma:</span>
        {Object.entries(counts).map(([type, count], index) => (
          <React.Fragment key={type}>
            <CBadge color={getBadgeColor(type)} className="mr-1">
              {count} {type}
              {count !== 1 ? "s" : ""}
            </CBadge>
            {index < Object.entries(counts).length - 1 && " "}
          </React.Fragment>
        ))}
      </div>
    );
  };

  // Método para formatar o texto do título
  getFormattedTitle = () => {
    const { existingUsersPagination } = this.state;
    const counts = this.getUserTypeCounts();
    const total = existingUsersPagination.total;

    if (total === 0) {
      return "Usuários na turma";
    }

    // Formata a string com os tipos
    const typeStrings = [];
    for (const [type, count] of Object.entries(counts)) {
      typeStrings.push(`${count} ${type}${count !== 1 ? "s" : ""}`);
    }

    // Ordena para ter um padrão (opcional: colocar usuários primeiro)
    typeStrings.sort((a, b) => {
      if (a.includes("Aluno")) return -1;
      if (b.includes("Aluno")) return 1;
      return 0;
    });

    return `Usuários na turma`;
  };

  // Método para redirecionar para listagem de turmas
  handleGoToList = () => {
    this.props.history.push("/classroom/list");
  };

  renderUserTypeCounts = () => {
    const { allClassroomUsers } = this.state;
    const counts = this.getUserTypeCounts();
    const total = allClassroomUsers?.length || 0;

    console.log("renderUserTypeCounts - total:", total);
    console.log("renderUserTypeCounts - counts:", counts);

    if (total === 0) {
      return <span>Usuários na turma</span>;
    }

    const getBadgeColor = type => {
      switch (type) {
        case "Estudante":
          return "info"; // Azul
        case "Aluno":
          return "info"; // Azul (caso venha como "Aluno")
        case "Professor":
          return "success"; // Verde
        case "Administrador Escolar":
          return "danger"; // Vermelho
        case "Administrador":
          return "danger"; // Vermelho
        case "Coordenador":
          return "warning"; // Amarelo/Laranja
        case "Diretor":
          return "dark"; // Preto/Cinza escuro
        case "Secretário":
          return "secondary"; // Cinza
        case "Responsável":
          return "primary"; // Azul escuro
        case "Supervisor":
          return "purple"; // Roxo (pode precisar de CSS customizado)
        default:
          return "secondary"; // Cinza padrão
      }
    };

    // Cores personalizadas com estilo inline para cores que não existem no CoreUI
    const getCustomStyle = type => {
      switch (type) {
        case "Supervisor":
          return { backgroundColor: "#6f42c1", color: "white" };
        case "Psicólogo":
          return { backgroundColor: "#20c997", color: "white" };
        case "Orientador":
          return { backgroundColor: "#fd7e14", color: "white" };
        default:
          return {};
      }
    };

    return (
      <div>
        <span className="mr-2">Usuários na turma:</span>
        {Object.entries(counts).map(([type, count], index) => {
          const badgeColor = getBadgeColor(type);
          const customStyle = getCustomStyle(type);

          // Se for uma cor personalizada (não padrão do CoreUI)
          if (Object.keys(customStyle).length > 0) {
            return (
              <React.Fragment key={type}>
                <CBadge
                  style={{
                    ...customStyle,
                    marginRight: "4px",
                    padding: "4px 8px"
                  }}
                  className="mr-1"
                >
                  {count} {type}
                  {count !== 1 ? "s" : ""}
                </CBadge>
                {index < Object.entries(counts).length - 1 && " "}
              </React.Fragment>
            );
          }

          // Para cores padrão do CoreUI
          return (
            <React.Fragment key={type}>
              <CBadge
                color={badgeColor}
                className="mr-1"
                style={{ padding: "4px 8px" }}
              >
                {count} {type}
                {count !== 1 ? "s" : ""}
              </CBadge>
              {index < Object.entries(counts).length - 1 && " "}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  render() {
    const {
      loading: isLoading,
      saving,
      existingUsers,
      roomDisciplines,
      room: roomData,
      showDisciplineModal,
      selectedDisciplinesForBatch,
      showEditModal,
      editingUser,
      editingDisciplines,
      selectedAvailableUsers,
      selectAllAvailable,
      userSearchTerm,
      existingUserSearchTerm,
      pendingBatches,
      existingUsersPagination,
      availableUsersPagination,
      showInformationModal,
      activeIndex,
      serieAbbreviation
    } = this.state;

    // Obtém os dados paginados dos usuarios disponíveis
    const {
      users: paginatedAvailableUsers,
      total: availableTotal,
      lastPage: availableLastPage,
      currentPage: availableCurrentPage
    } = this.getPaginatedAvailableUsers();

    // Filtra os usuários existentes pela busca
    const filteredExistingUsers = userSearchTerm
      ? existingUsers.filter(
          user =>
            user.name?.toLowerCase().includes(userSearchTerm.toLowerCase()) ||
            user.role_name?.toLowerCase().includes(userSearchTerm.toLowerCase()) // ADICIONE ESTA LINHA
        )
      : existingUsers;

    console.log("=== RENDER ===");
    console.log("isLoading:", isLoading);
    console.log("existingUsers length:", existingUsers.length);
    console.log("filteredExistingUsers length:", filteredExistingUsers.length);
    console.log(
      "paginatedAvailableUsers length:",
      paginatedAvailableUsers.length
    );
    console.log("availableTotal:", availableTotal);

    if (isLoading) {
      return (
        <div
          className="animated fadeIn d-flex justify-content-center"
          style={{ minHeight: "100vh" }}
        >
          <CSpinner color="primary" />
        </div>
      );
    }

    if (!roomData && !isLoading) {
      return (
        <div
          className="animated fadeIn d-flex justify-content-center"
          style={{ minHeight: "100vh" }}
        >
          <CAlert color="warning">Carregando dados da turma...</CAlert>
        </div>
      );
    }

    return (
      <>
        <CModal
          show={showInformationModal}
          centered
          size="lg"
          backdrop="static"
          onClose={() =>
            this.setState({ showInformationModal: false, activeIndex: 0 })
          }
          className="tutorial-modal"
        >
          <CModalHeader closeButton>
            <CModalTitle className="text-primary font-weight-bold">
              Tutorial: Enturmação de membros da turma
            </CModalTitle>
          </CModalHeader>
          <CModalBody
            className="p-4"
            style={{ overflowY: "auto", maxHeight: "60vh" }}
          >
            <div className="mb-3">
              <div
                style={{
                  height: "6px",
                  borderRadius: "3px",
                  backgroundColor: "#e9ecef"
                }}
              >
                <div
                  style={{
                    width: `${
                      ((activeIndex + 1) / this.carouselItems.length) * 100
                    }%`,
                    backgroundColor: "#0d6efd",
                    height: "6px",
                    borderRadius: "3px",
                    transition: "width 0.4s ease"
                  }}
                />
              </div>
            </div>
            <div
              className="fade-in d-flex align-items-center justify-content-center flex-wrap"
              style={{ gap: "20px" }}
            >
              <div style={{ flex: "0 0 65%", textAlign: "center" }}>
                <img
                  src={this.carouselItems[activeIndex].image}
                  alt={this.carouselItems[activeIndex].title}
                  style={{
                    height: "320px",
                    width: "100%",
                    objectFit: "contain",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "10px",
                    boxShadow: "0 0 10px rgba(0,0,0,0.1)"
                  }}
                />
              </div>
              <div style={{ flex: "0 0 30%", textAlign: "left" }}>
                <h3 className="text-primary mb-2">
                  {this.carouselItems[activeIndex].title}
                </h3>
                <h4 className="text-primary mb-3">
                  {this.carouselItems[activeIndex].subtitle}
                </h4>
                <p className="text-muted" style={{ fontSize: "1.05rem" }}>
                  {this.carouselItems[activeIndex].content}
                </p>
              </div>
            </div>
          </CModalBody>
          <CModalFooter className="d-flex justify-content-between">
            {activeIndex >= 1 && (
              <CButton
                color="primary"
                variant="outline"
                onClick={this.previous}
              >
                <FaChevronLeft className="mr-2" /> Anterior
              </CButton>
            )}
            <div className="d-flex gap-2">
              {this.carouselItems.map((_, index) => (
                <button
                  key={index}
                  className={`rounded-circle ${
                    index === activeIndex ? "bg-primary" : "bg-secondary"
                  }`}
                  onClick={() => this.goToIndex(index)}
                  style={{
                    width: "12px",
                    height: "12px",
                    border: "none",
                    opacity: index === activeIndex ? 1 : 0.6,
                    cursor: "pointer"
                  }}
                />
              ))}
            </div>
            {activeIndex === this.carouselItems.length - 1 ? (
              <CButton
                color="primary"
                onClick={() =>
                  this.setState({ showInformationModal: false, activeIndex: 0 })
                }
              >
                <FaCheck className="mr-2" /> Concluir Tutorial
              </CButton>
            ) : (
              <CButton color="primary" onClick={this.next}>
                Próximo <FaChevronRight className="ml-2" />
              </CButton>
            )}
          </CModalFooter>
        </CModal>

        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/classroom/list", to: "/classroom/list" }]}
        />

        <CCard>
          <Prompt
            when={pendingBatches.length > 0}
            message="Existem lotes pendentes. Tem certeza de que deseja sair?"
          />

          <CCardHeader className="d-flex align-items-center justify-content-between">
            <div>
              <h4 className="card-title mb-1">Editar membros da turma</h4>
              <div className="mt-2 d-flex align-items-center">
                <h2 className="mb-0 font-weight-bold text-primary">
                  {roomData?.name || "Carregando..."}
                </h2>
              </div>
            </div>
            <div>
              <CButton
                color="success"
                className="mr-2"
                onClick={this.handleGoToList}
              >
                <FaSave className="mr-2" />
                Finalizar
              </CButton>
              <CButton
                color="info"
                onClick={() => this.setState({ showInformationModal: true })}
              >
                <FaInfoCircle className="mr-2" /> Ajuda
              </CButton>
            </div>
          </CCardHeader>

          <CCardBody>
            {pendingBatches.length > 0 && (
              <CAlert color="info" className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{pendingBatches.length} lote(s) pendente(s)</strong>
                    <br />
                    Total:{" "}
                    {pendingBatches.reduce(
                      (sum, b) => sum + b.users.length,
                      0
                    )}{" "}
                    usuário(s)
                  </div>
                  <div>
                    <CButton
                      color="success"
                      size="sm"
                      onClick={this.handleSaveAllBatches}
                      disabled={saving}
                    >
                      {saving ? (
                        <CSpinner size="sm" />
                      ) : (
                        <FaSave className="mr-1" />
                      )}{" "}
                      Salvar Tudo
                    </CButton>{" "}
                    <CButton
                      color="danger"
                      size="sm"
                      onClick={this.handleCancelAllBatches}
                    >
                      <FaTimes className="mr-1" /> Cancelar
                    </CButton>
                  </div>
                </div>
              </CAlert>
            )}
            {pendingBatches.length > 0 && (
              <div className="mb-4">
                <h6>Lotes Pendentes:</h6>
                {pendingBatches.map(batch => (
                  <div
                    key={batch.id}
                    className="border p-2 mb-2 rounded d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <CBadge color="primary">
                        {batch.users.length} usuário(s)
                      </CBadge>{" "}
                      <CBadge color="success">
                        {batch.disciplines
                          .map(d => {
                            const disc = roomDisciplines.find(
                              rd => rd.id === d
                            );
                            return disc?.discipline_name;
                          })
                          .filter(Boolean)
                          .join(", ")}
                      </CBadge>
                    </div>
                    <CButton
                      size="sm"
                      color="danger"
                      onClick={() => this.handleRemoveBatch(batch.id)}
                    >
                      <FaTrash />
                    </CButton>
                  </div>
                ))}
              </div>
            )}
            {/* Usuários na Turma - Primeiro */}
            <CCard className="mb-4">
              <CCardHeader className="bg-primary text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <h6 className="mb-0">{this.renderUserTypeCounts()}</h6>
                  <div className="d-flex flex-wrap">
                    {this.state.canManageTeachers &&
                      this.state.gradeEligibleForAuxiliary && (
                        <CButton
                          size="sm"
                          color="light"
                          className="mr-2 mb-1 mb-md-0"
                          onClick={this.handleOpenTeachersModal}
                        >
                          Professores
                        </CButton>
                      )}
                    {this.state.selectedExistingUsers.length > 0 && (
                      <div>
                        <CButton
                          size="sm"
                          color="warning"
                          className="mr-2"
                          onClick={this.handleBatchEdit}
                          disabled={this.state.saving}
                        >
                          <FaEdit className="mr-1" /> Ediar (
                          {this.state.selectedExistingUsers.length})
                        </CButton>
                        <CButton
                          size="sm"
                          color="danger"
                          onClick={this.handleBatchDeleteConfirm}
                          disabled={this.state.saving}
                        >
                          <FaUserSlash className="mr-1" /> Remover (
                          {this.state.selectedExistingUsers.length})
                        </CButton>
                      </div>
                    )}
                  </div>
                </div>
              </CCardHeader>
              <CCardBody>
                {/* Campo de busca para usuários existentes */}
                <div className="mb-3">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <FaSearch />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Buscar usuário na turma..."
                      value={userSearchTerm}
                      onChange={e =>
                        this.setState({ userSearchTerm: e.target.value })
                      }
                    />
                  </div>
                </div>

                <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                  {filteredExistingUsers.length === 0 ? (
                    <p className="text-muted text-center">
                      {userSearchTerm
                        ? "Nenhum usuário encontrado"
                        : "Nenhum usuário nesta turma"}
                    </p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th style={{ width: "40px" }}>
                              <input
                                type="checkbox"
                                checked={this.state.selectAllExisting}
                                onChange={this.toggleSelectAllExisting}
                              />
                            </th>
                            <th>Nome</th>
                            <th>Tipo</th>
                            <th>Série</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredExistingUsers.map(user => (
                            <tr key={user.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={this.state.selectedExistingUsers.includes(
                                    user.id
                                  )}
                                  onChange={() =>
                                    this.toggleSelectExistingUser(user.id)
                                  }
                                />
                              </td>
                              <td>{user.name}</td>
                              <td>
                                <CBadge
                                  color={
                                    user.role_name === "Aluno"
                                      ? "info"
                                      : "primary"
                                  }
                                >
                                  {user.role_name || "Usuário"}
                                </CBadge>
                                {Number(user.role_id) === 6 &&
                                  !user.administrator && (
                                    <CBadge color="secondary" className="ml-1">
                                      Auxiliar
                                    </CBadge>
                                  )}
                              </td>
                              <td>
                                {/* Mostrar séries do usuário existente */}
                                {user.user_disciplines &&
                                user.user_disciplines.length > 0 ? (
                                  [
                                    ...new Set(
                                      user.user_disciplines.map(
                                        d => d.serie_name
                                      )
                                    )
                                  ].map((serieName, idx) => (
                                    <CBadge
                                      key={idx}
                                      color="warning"
                                      className="mr-1"
                                    >
                                      {serieName}
                                    </CBadge>
                                  ))
                                ) : (
                                  <CBadge color="secondary">Sem série</CBadge>
                                )}
                              </td>
                              <td>
                                <CButton
                                  size="sm"
                                  color="warning"
                                  className="mr-1"
                                  onClick={() => this.handleEditUser(user)}
                                >
                                  <FaPencilAlt /> Modificar
                                </CButton>
                                <CButton
                                  size="sm"
                                  color="danger"
                                  onClick={() => this.handleRemoveUser(user)}
                                >
                                  <FaTrash /> Remover
                                </CButton>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {existingUsersPagination.lastPage > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <CButton
                      size="sm"
                      disabled={existingUsersPagination.currentPage === 1}
                      onClick={() =>
                        this.loadExistingUsers(
                          existingUsersPagination.currentPage - 1
                        )
                      }
                    >
                      Anterior
                    </CButton>
                    <span className="mx-3">
                      Página {existingUsersPagination.currentPage} de{" "}
                      {existingUsersPagination.lastPage}
                    </span>
                    <CButton
                      size="sm"
                      disabled={
                        existingUsersPagination.currentPage ===
                        existingUsersPagination.lastPage
                      }
                      onClick={() =>
                        this.loadExistingUsers(
                          existingUsersPagination.currentPage + 1
                        )
                      }
                    >
                      Próxima
                    </CButton>
                  </div>
                )}
              </CCardBody>
            </CCard>
            {/* Adicionar Usuários - Segundo */}
            <CCard>
              <CCardHeader className="bg-success text-white">
                <h6 className="mb-0">Adicionar usuários na turma</h6>
              </CCardHeader>
              <CCardBody>
                {/* Campo de busca para usuários disponíveis */}
                <div className="mb-3">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <FaSearch />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Buscar usuário..."
                      value={existingUserSearchTerm}
                      onChange={e =>
                        this.handleAvailableUsersSearch(e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <CButton
                    color="primary"
                    onClick={this.handleOpenDisciplineModal}
                    disabled={selectedAvailableUsers.length === 0}
                  >
                    <FaPlus /> Atribuir Disciplinas (
                    {selectedAvailableUsers.length})
                  </CButton>
                </div>

                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {paginatedAvailableUsers.length === 0 ? (
                    <p className="text-muted text-center">
                      {existingUserSearchTerm
                        ? "Nenhum usuário encontrado"
                        : "Nenhum usuário disponível"}
                    </p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th style={{ width: "40px" }}>
                              <input
                                type="checkbox"
                                checked={selectAllAvailable}
                                onChange={() => {
                                  const allCurrentIds =
                                    paginatedAvailableUsers.map(u => u.id);
                                  const allSelected = allCurrentIds.every(id =>
                                    selectedAvailableUsers.includes(id)
                                  );

                                  if (allSelected) {
                                    this.setState(prevState => ({
                                      selectedAvailableUsers:
                                        prevState.selectedAvailableUsers.filter(
                                          id => !allCurrentIds.includes(id)
                                        ),
                                      selectAllAvailable: false
                                    }));
                                  } else {
                                    const newSelected = [
                                      ...selectedAvailableUsers
                                    ];
                                    allCurrentIds.forEach(id => {
                                      if (!newSelected.includes(id)) {
                                        newSelected.push(id);
                                      }
                                    });
                                    this.setState({
                                      selectedAvailableUsers: newSelected,
                                      selectAllAvailable: true
                                    });
                                  }
                                }}
                              />
                            </th>
                            <th>Nome</th>
                            <th>Tipo</th> {/* NOVA COLUNA */}
                            <th>Usuário</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedAvailableUsers.map(user => (
                            <tr key={user.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedAvailableUsers.includes(
                                    user.id
                                  )}
                                  onChange={() =>
                                    this.toggleSelectUser(user.id)
                                  }
                                />
                              </td>
                              <td>
                                {user.name}
                                {/* BADGE COM OS NOMES DAS SÉRIES AO LADO DO NOME */}
                                {user.grade_names && user.grade_names.length > 0
                                  ? user.grade_names.map((gradeName, idx) => (
                                      <CBadge
                                        key={idx}
                                        color="warning"
                                        className="ml-1"
                                      >
                                        {gradeName}
                                      </CBadge>
                                    ))
                                  : user.grade_ids &&
                                    user.grade_ids.length > 0 && (
                                      <CBadge
                                        color="secondary"
                                        className="ml-1"
                                      >
                                        Série {user.grade_ids.join(", ")}
                                      </CBadge>
                                    )}
                              </td>
                              <td>
                                <CBadge
                                  color={
                                    user.role_name === "Aluno"
                                      ? "info"
                                      : "primary"
                                  }
                                >
                                  {user.role_name || "Usuário"}
                                </CBadge>
                              </td>
                              <td>{user.email?.split("@")[0] || user.email}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* Paginação dos usuarios disponíveis */}
                {availableLastPage > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <CButton
                      size="sm"
                      disabled={availableCurrentPage === 1}
                      onClick={() =>
                        this.handleAvailableUsersPageChange(
                          availableCurrentPage - 1
                        )
                      }
                    >
                      Anterior
                    </CButton>
                    <span className="mx-3">
                      Página {availableCurrentPage} de {availableLastPage}
                    </span>
                    <CButton
                      size="sm"
                      disabled={availableCurrentPage === availableLastPage}
                      onClick={() =>
                        this.handleAvailableUsersPageChange(
                          availableCurrentPage + 1
                        )
                      }
                    >
                      Próxima
                    </CButton>
                  </div>
                )}
              </CCardBody>
            </CCard>
          </CCardBody>
        </CCard>

        <CModal
          show={showDisciplineModal}
          onClose={() => this.setState({ showDisciplineModal: false })}
          size="lg"
          className="discipline-modal"
        >
          <CModalHeader
            closeButton
            className="bg-primary text-white"
            style={{ width: "100%", padding: "1rem 1.5rem" }}
          >
            <CModalTitle
              className="d-flex align-items-center"
              style={{ width: "100%" }}
            >
              <FaPlus className="mr-2" /> Atribuir Disciplinas
            </CModalTitle>
          </CModalHeader>

          <CModalBody className="p-3">
            {/* Card de usuários selecionados */}
            <div className="bg-light p-3 rounded mb-3">
              <div className="d-flex align-items-center mb-2">
                <CBadge
                  color="primary"
                  className="mr-2"
                  style={{ fontSize: "0.9rem", padding: "4px 8px" }}
                >
                  {this.state.selectedUsersForBatch?.length}
                </CBadge>
                <strong className="text-primary">
                  usuário(s) selecionado(s)
                </strong>
              </div>
              <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                {this.state.selectedUsersForBatch?.map((u, idx) => (
                  <CBadge
                    key={idx}
                    color="info"
                    className="mr-1 mb-1"
                    style={{ fontSize: "0.85rem", padding: "4px 8px" }}
                  >
                    {u.name}
                  </CBadge>
                ))}
              </div>
            </div>

            {/* Seção de disciplinas com cabeçalho e botão selecionar todas */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="mb-0 d-flex align-items-center">
                <FaCheck className="text-success mr-2" />
                Disciplinas disponíveis:
              </h6>
              <CButton
                size="sm"
                color="link"
                className="p-0"
                onClick={() => {
                  if (
                    selectedDisciplinesForBatch.length ===
                    roomDisciplines.length
                  ) {
                    // Se todas já estão selecionadas, desmarca todas
                    this.setState({ selectedDisciplinesForBatch: [] });
                  } else {
                    // Senão, seleciona todas
                    const allDisciplineIds = roomDisciplines.map(d => d.id);
                    this.setState({
                      selectedDisciplinesForBatch: allDisciplineIds
                    });
                  }
                }}
              ></CButton>
            </div>

            {roomDisciplines.length === 0 ? (
              <CAlert color="warning" className="text-center py-2">
                <FaInfoCircle className="mr-2" />
                Nenhuma disciplina cadastrada para esta turma
              </CAlert>
            ) : (
              <div
                className="border rounded"
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                <table className="table table-sm table-hover mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th style={{ width: "40px" }} className="text-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ cursor: "pointer" }}
                          checked={
                            selectedDisciplinesForBatch.length ===
                              roomDisciplines.length &&
                            roomDisciplines.length > 0
                          }
                          onChange={() => {
                            if (
                              selectedDisciplinesForBatch.length ===
                              roomDisciplines.length
                            ) {
                              this.setState({
                                selectedDisciplinesForBatch: []
                              });
                            } else {
                              const allDisciplineIds = roomDisciplines.map(
                                d => d.id
                              );
                              this.setState({
                                selectedDisciplinesForBatch: allDisciplineIds
                              });
                            }
                          }}
                        />
                      </th>
                      <th>Disciplina</th>
                      <th style={{ width: "30%" }}>Série</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roomDisciplines.map(discipline => (
                      <tr
                        key={discipline.id}
                        className={
                          selectedDisciplinesForBatch.includes(discipline.id)
                            ? "table-active"
                            : ""
                        }
                      >
                        <td className="text-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ cursor: "pointer" }}
                            checked={selectedDisciplinesForBatch.includes(
                              discipline.id
                            )}
                            onChange={e => {
                              if (e.target.checked) {
                                this.setState(prevState => ({
                                  selectedDisciplinesForBatch: [
                                    ...prevState.selectedDisciplinesForBatch,
                                    discipline.id
                                  ]
                                }));
                              } else {
                                this.setState(prevState => ({
                                  selectedDisciplinesForBatch:
                                    prevState.selectedDisciplinesForBatch.filter(
                                      id => id !== discipline.id
                                    )
                                }));
                              }
                            }}
                          />
                        </td>
                        <td>
                          <span className="font-weight-bold">
                            {discipline.discipline_name}
                          </span>
                        </td>
                        <td>
                          <CBadge
                            color="warning"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {discipline.serie_name}
                          </CBadge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Resumo das disciplinas selecionadas */}
            {selectedDisciplinesForBatch.length > 0 && (
              <div
                className="mt-3 p-2 rounded"
                style={{ backgroundColor: "#d4edda" }}
              >
                <small className="text-success">
                  <FaCheck className="mr-1" />
                  {selectedDisciplinesForBatch.length} disciplina(s)
                  selecionada(s)
                </small>
              </div>
            )}
          </CModalBody>

          <CModalFooter className="bg-light">
            <CButton
              color="secondary"
              onClick={() =>
                this.setState({
                  showDisciplineModal: false,
                  selectedDisciplinesForBatch: []
                })
              }
            >
              <FaTimes className="mr-1" /> Cancelar
            </CButton>
            <CButton
              color="primary"
              onClick={this.handleConfirmBatch}
              disabled={selectedDisciplinesForBatch.length === 0}
            >
              <FaSave className="mr-1" /> Adicionar (
              {selectedDisciplinesForBatch.length})
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          show={showEditModal}
          onClose={() => this.setState({ showEditModal: false })}
          size="lg"
        >
          <CModalHeader closeButton>
            <CModalTitle>
              Modificar Disciplinas - {editingUser?.name}
            </CModalTitle>
          </CModalHeader>
          <CModalBody>
            <h6>Selecione as disciplinas que este usuário deve ter:</h6>
            {roomDisciplines.length === 0 ? (
              <p className="text-muted">Nenhuma disciplina cadastrada</p>
            ) : (
              roomDisciplines.map(discipline => (
                <div key={discipline.id} className="mb-2">
                  <label className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={editingDisciplines.includes(discipline.id)}
                      onChange={e => {
                        if (e.target.checked) {
                          this.setState(prevState => ({
                            editingDisciplines: [
                              ...prevState.editingDisciplines,
                              discipline.id
                            ]
                          }));
                        } else {
                          this.setState(prevState => ({
                            editingDisciplines:
                              prevState.editingDisciplines.filter(
                                id => id !== discipline.id
                              )
                          }));
                        }
                      }}
                    />
                    <span>
                      {discipline.discipline_name} - {discipline.serie_name}
                    </span>
                  </label>
                </div>
              ))
            )}
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() => this.setState({ showEditModal: false })}
            >
              Cancelar
            </CButton>
            <CButton
              color="primary"
              onClick={this.handleSaveEdit}
              disabled={saving}
            >
              {saving ? <CSpinner size="sm" /> : "Salvar Alterações"}
            </CButton>
          </CModalFooter>
        </CModal>
        {/* Modal de edição em lote */}
        <CModal
          show={this.state.showBatchEditModal}
          onClose={() =>
            this.setState({ showBatchEditModal: false, editingDisciplines: [] })
          }
          size="lg"
        >
          <CModalHeader closeButton>
            <CModalTitle>
              Editar Disciplinas em Lote (
              {this.state.selectedExistingUsers.length} usuário(s))
            </CModalTitle>
          </CModalHeader>
          <CModalBody>
            <h6>
              Selecione as disciplinas para todos os usuários selecionados:
            </h6>
            {roomDisciplines.length === 0 ? (
              <p className="text-muted">Nenhuma disciplina cadastrada</p>
            ) : (
              roomDisciplines.map(discipline => (
                <div key={discipline.id} className="mb-2">
                  <label className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={this.state.editingDisciplines.includes(
                        discipline.id
                      )}
                      onChange={e => {
                        if (e.target.checked) {
                          this.setState(prevState => ({
                            editingDisciplines: [
                              ...prevState.editingDisciplines,
                              discipline.id
                            ]
                          }));
                        } else {
                          this.setState(prevState => ({
                            editingDisciplines:
                              prevState.editingDisciplines.filter(
                                id => id !== discipline.id
                              )
                          }));
                        }
                      }}
                    />
                    <span>
                      {discipline.discipline_name} - {discipline.serie_name}
                    </span>
                  </label>
                </div>
              ))
            )}
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() =>
                this.setState({
                  showBatchEditModal: false,
                  editingDisciplines: []
                })
              }
            >
              Cancelar
            </CButton>
            <CButton
              color="primary"
              onClick={this.handleBatchEditSave}
              disabled={
                this.state.saving || this.state.editingDisciplines.length === 0
              }
            >
              {this.state.saving ? <CSpinner size="sm" /> : "Salvar em Todos"}
            </CButton>
          </CModalFooter>
        </CModal>

        {/* Modal de Professores (titular/auxiliar) */}
        <CModal
          show={this.state.showTeachersModal}
          onClose={this.handleCancelTeachersModal}
          size="lg"
        >
          <CModalHeader closeButton>
            <CModalTitle>Professores</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {this.state.loadingTeachers ? (
              <div className="text-center">
                <CSpinner size="sm" />
              </div>
            ) : this.state.teacherRows.length === 0 ? (
              <p className="text-muted">Nenhum professor nesta turma</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Professor principal</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.teacherRows.map(teacher => {
                      const isChecked =
                        teacher.id in this.state.pendingAdministratorChanges
                          ? this.state.pendingAdministratorChanges[teacher.id]
                          : teacher.administrator;

                      return (
                        <tr key={teacher.id}>
                          <td>
                            <div className="custom-control custom-switch">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`teacher-toggle-${teacher.id}`}
                                checked={isChecked}
                                onChange={() =>
                                  this.handleTeacherToggle(
                                    teacher.id,
                                    isChecked
                                  )
                                }
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`teacher-toggle-${teacher.id}`}
                              ></label>
                            </div>
                          </td>
                          <td>{teacher.name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={this.handleCancelTeachersModal}>
              Cancelar
            </CButton>
            <CButton
              color="primary"
              onClick={this.handleSaveTeachers}
              disabled={this.state.savingTeachers}
            >
              {this.state.savingTeachers ? (
                <CSpinner size="sm" />
              ) : (
                "Salvar Alterações"
              )}
            </CButton>
          </CModalFooter>
        </CModal>

        {/* Modal de confirmação de exclusão em lote */}
        <CModal
          show={this.state.showBatchDeleteConfirm}
          onClose={() => this.setState({ showBatchDeleteConfirm: false })}
        >
          <CModalHeader closeButton>
            <CModalTitle>Confirmar Exclusão em Lote</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p>
              Tem certeza que deseja remover{" "}
              <strong>{this.state.selectedExistingUsers.length}</strong>{" "}
              usuário(s) da turma?
            </p>
            <p className="text-danger">Esta ação não poderá ser desfeita.</p>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() => this.setState({ showBatchDeleteConfirm: false })}
            >
              Cancelar
            </CButton>
            <CButton
              color="danger"
              onClick={this.handleBatchDelete}
              disabled={this.state.saving}
            >
              {this.state.saving ? <CSpinner size="sm" /> : "Confirmar Remoção"}
            </CButton>
          </CModalFooter>
        </CModal>

        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user || {},
  general: state.general || {},
  profile: state.profile || {},
  currentRoute: state.navigation?.currentRoute || null
});

function mapDispatchToProps(dispatch) {}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomMembers);
